export function GitLabIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.6 9.593l-.033-.086L20.3.98a.851.851 0 00-.336-.405.875.875 0 00-1 .054.875.875 0 00-.29.44L16.47 7.79H7.537L5.333 1.07a.858.858 0 00-.29-.441.875.875 0 00-1-.054.858.858 0 00-.336.405L.437 9.502l-.032.086a6.066 6.066 0 002.012 7.01l.011.009.03.021 4.977 3.727 2.462 1.863 1.5 1.132a1.009 1.009 0 001.22 0l1.499-1.132 2.462-1.863 5.006-3.75.013-.01a6.068 6.068 0 002.004-7.002z" />
    </svg>
  );
}
